/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_UnavailableInputs */

const en_delivery_board_unavailable = /** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance Unavailable`)
};

const es_delivery_board_unavailable = /** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distancia No Disponible`)
};

const fr_delivery_board_unavailable = /** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance indisponible`)
};

const de_delivery_board_unavailable = /** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernung nicht verfügbar`)
};

const id_delivery_board_unavailable = /** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jarak Tidak Tersedia`)
};

/** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */
const ja_delivery_board_unavailable = en_delivery_board_unavailable;

/** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */
const zh_delivery_board_unavailable = en_delivery_board_unavailable;

/** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */
const ar_delivery_board_unavailable = en_delivery_board_unavailable;

/** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */
const it_delivery_board_unavailable = en_delivery_board_unavailable;

/** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */
const ru_delivery_board_unavailable = en_delivery_board_unavailable;

/** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */
const pt_delivery_board_unavailable = en_delivery_board_unavailable;

/** @type {(inputs: Delivery_Board_UnavailableInputs) => LocalizedString} */
const ko_delivery_board_unavailable = en_delivery_board_unavailable;

/**
* | output |
* | --- |
* | "Distance Unavailable" |
*
* @param {Delivery_Board_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_unavailable = /** @type {((inputs?: Delivery_Board_UnavailableInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_UnavailableInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_unavailable(inputs)
	if (locale === "es") return es_delivery_board_unavailable(inputs)
	if (locale === "fr") return fr_delivery_board_unavailable(inputs)
	if (locale === "de") return de_delivery_board_unavailable(inputs)
	if (locale === "ja") return ja_delivery_board_unavailable(inputs)
	if (locale === "zh") return zh_delivery_board_unavailable(inputs)
	if (locale === "ar") return ar_delivery_board_unavailable(inputs)
	if (locale === "id") return id_delivery_board_unavailable(inputs)
	if (locale === "it") return it_delivery_board_unavailable(inputs)
	if (locale === "ru") return ru_delivery_board_unavailable(inputs)
	if (locale === "pt") return pt_delivery_board_unavailable(inputs)
	return ko_delivery_board_unavailable(inputs)
});